export default "__VITE_ASSET__c27811c2__"